import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { BUTTON_VARIANTS, TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { appStorage } from "@miplatform/utils";
import { Box, DialogContent, Divider, Modal, Typography } from "@mui/material";
import { MiButton } from "../MiButton/MiButton";
import { MiCheckbox } from "../MiCheckbox/MiCheckbox";
import { MiIcon } from "../MiIcon/MiIcon";

export function MiAlertModal({
  title,
  titleIcon,
  subtitle,
  description,
  position,
  storageKey,
  closeLabel,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const { classes } = useStyles({ position });

  useEffect(() => {
    const isVisible = appStorage.getItem(storageKey);
    setIsOpen(!isVisible);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    if (dontShowAgain && storageKey) {
      appStorage.setItem(storageKey, true);
    }
  };

  return (
    <Modal open={isOpen} className={classes.modal}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <MiIcon path={titleIcon} size={0.8} />
          <Typography variant={TYPOGRAPHY_VARIANTS.BODY1} fontWeight={600}>
            {title}
          </Typography>
        </Box>
        <DialogContent className={classes.content}>
          <Typography fontWeight={600}>{subtitle}</Typography>
          <Divider />
          <Typography variant={TYPOGRAPHY_VARIANTS.BODY2}>
            {description}
          </Typography>
          <Box className={classes.footer}>
            <MiCheckbox
              label="Don't Show Again"
              value={dontShowAgain}
              handleChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <MiButton
              title={closeLabel}
              variant={BUTTON_VARIANTS.CONTAINED}
              onClick={handleClose}
            />
          </Box>
        </DialogContent>
      </Box>
    </Modal>
  );
}

const useStyles = makeStyles()((theme, { position }) => {
  const modalPosition = position && {
    position: "relative",
    top: position.top,
    left: position.left,
    transform: "translate(-50%, -50%)",
  };

  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    container: {
      width: 400,
      backgroundColor: theme.palette.orange.light,
      padding: theme.spacing(2),
      borderRadius: theme.spacing(2),
      outline: "none",
      ...modalPosition,
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    content: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2),
      borderRadius: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
    },
  };
});
